var violacoes = function () {
    var validador = function (formulario) {
        return $(formulario).parsley({
            excluded: ".parsley-excluded, div.nao-validar input[propriedade], div.nao-validar select[propriedade], div.nao-validar textarea[propriedade]"
        });
    };

    var limpar = function (formulario) {
        validador(formulario).reset();
    };

    var validarClient = function (formulario) {
        limpar(formulario);
        return validador(formulario).validate();
    };

    var preparaMensagemSemVinculo = function (inconsistenciasSemVinculo) {
        if (inconsistenciasSemVinculo == undefined || inconsistenciasSemVinculo.length === 0) {
            return undefined;
        }

        var erro = "";

        inconsistenciasSemVinculo.forEach(function (e) {
            erro += "<span> <strong> " + e.Propriedade + " </strong> - " + e.Mensagem + "</span> </br>";
        });

        var mensagemCompleta = "<strong>Erro! Verifique as regras: </strong></br>" + erro;

        return mensagemCompleta;
    };

    var preparaMensagemViolacao = function (inconsistenciasSemVinculo) {
        if (inconsistenciasSemVinculo == undefined || inconsistenciasSemVinculo.length === 0) {
            return undefined;
        }

        var erro = "";

        inconsistenciasSemVinculo.forEach(function (e) {
            erro += "<span> <strong> " + e.Propriedade + " </strong> " + e.Mensagem + "</span> </br>";
        });

        return erro;
    };

    var exibir = function (formulario, inconsistencias, mensagemDetalhada) {
        limpar(formulario);

        if (inconsistencias === null || inconsistencias === undefined) {
            notificacao.erro(mensagemDetalhada);
        } else {
            var inconsistenciasSemVinculo = [];
            inconsistencias.forEach(function (elemento, indice) {
                var encontrado = false;
                validador(formulario).fields.forEach(function (e) {
                    var propriedade = e.$element.attr("Propriedade");
                    var nome = e.$element.attr("Name");
                    if (propriedade != undefined && elemento.Propriedade === propriedade) {
                        ParsleyUI.addError(e, nome, elemento.Mensagem);
                        encontrado = true;
                    }
                });

                if (!encontrado) {
                    inconsistenciasSemVinculo[indice] = elemento;
                }
            });

            notificacao.erro(preparaMensagemSemVinculo(inconsistenciasSemVinculo));
        }

    };

    var listaMensagens = function (violacoes) {

        if (!violacoes) return;

        var mensagensViolacoes = violacoes.map(function (violacao) { return violacao.Mensagem });

        var html = mensagensViolacoes.map(function (element) {
            return "<br> - " + element;
        }).join("");

        return html;
    }

    return {
        validarClient: validarClient,
        exibir: exibir,
        preparaMensagemViolacao: preparaMensagemViolacao,
        preparaMensagemSemVinculo: preparaMensagemSemVinculo,
        listaMensagens: listaMensagens

    }
}();